import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadPortalSettings, loadPortalSettingsFailed, loadPortalSettingsSuccess } from "../actions/portal.actions";
import { catchError, map, mergeMap } from 'rxjs/operators';
import { PortalService } from "src/app/services/portal/portal.service";

@Injectable()
export class PortalEffects {
	private actions$ = inject(Actions);
	private portalService = inject(PortalService);


	// Load the portal settings from backend blob storage
	loadPortalSettings$ = createEffect(() => this.actions$.pipe(
		ofType(loadPortalSettings),
		mergeMap(() =>
			this.portalService.getPortalSettings().pipe(
				map(resp => loadPortalSettingsSuccess({ portalSettings: resp.data })),
				catchError(async (error) => loadPortalSettingsFailed({ error: error }))
			)
		)
	));

}
